import React, { useEffect, useState } from 'react';
import style from "./MSM101F1.module.scss";
import { postData } from "../../utils/TransactionUtil";
import Table from "../../components/Table/Table";
import DataGrid from "../../components/DataGrid/DataGrid";

// 메뉴 트리 데이터를 가져오고 트리 구조로 렌더링
const MSM101F1 = ({navBar: NavBar}) => {

    const [menuData, setMenuData] = useState([]);
    const [menuInfo, setMenuInfo] = useState({});

    useEffect(() => {
        const getMenuTreeList = async () => {
        const res = await postData("/MSM/getMenuTreeList", {});
            setMenuData(res);
        };
        getMenuTreeList();
    }, []);

    const handleClick_node = (tarMenuId) => {
        const getMenuDetail = async () => {
            const param = {
                menuId : tarMenuId
            }
            const res = await postData("/MSM/getMenuDetail", param);
            setMenuInfo(res?.MenuInfo);
            setRows_RolesList(res?.RolesList)
        };
        getMenuDetail();
    }

    const [rows_RolesList, setRows_RolesList] = useState([]);
    const cols_RolesList = [
        { key: 'roleNm',       name: '역할명',       width: '25%'},
        { key: 'roleDscr',     name: '역할설명',     width: '25%' },
        { key: 'roleUseYn',     name: '사용여부',     width: '25%' },
        { key: 'modInfo',     name: '수정정보',   width: '25%', cellClass: 'align_left' },
    ];



  return (
        <main className={style.main_wrap}>
            <NavBar>
                {/*Nav 내용*/}
            </NavBar>
            <div className={style.contBox}>
                <div className={style.contItem}>
                    <h6 className={style.contItem__title}>메뉴리스트</h6>
                    <div className={style.contItem__content}>
                        <TreeNode data={menuData} handleClick={handleClick_node} />
                    </div>
                </div>
                <div className={style.contItem}>
                    <h6 className={style.contItem__title}>메뉴상세리스트</h6>
                    <div className={style.contItem__content}>
                        <Table variant="default" rowCnt={6} colSize={["200px","350px","200px","auto"]} rowSize="42px" >
                            <div>상위메뉴</div>
                            <div className="col_merge"><input type="text" value={menuInfo?.hgrnMenuId}/></div>
                            <div>메뉴코드</div>
                            <div className="col_merge"><input type="text" value={menuInfo?.menuId}/></div>
                            <div>메뉴명</div>
                            <div><input type="text" value={menuInfo?.menuNm}/></div>
                            <div>메뉴유형</div>
                            <div><input type="text" value={menuInfo?.menuType}/></div>
                            <div>URL</div>
                            <div className="col_merge"><input type="text" value={menuInfo?.menuUrl}/></div>
                            <div>메뉴설명</div>
                            <div className="col_merge"><input type="text" value={menuInfo?.menuDscr}/></div>
                            <div>사용유무</div>
                            <div><input type="text" value={menuInfo?.menuExrnYn}/></div>
                            <div>정렬순서</div>
                            <div><input type="text" value={menuInfo?.sortSqnc}/></div>
                        </Table>

                    </div>
                </div>
                <div className={style.contItem}>
                    <h6 className={style.contItem__title}>역할리스트</h6>
                    <div className={style.contItem__content}>
                        <DataGrid
                            cols={cols_RolesList}
                            rows={rows_RolesList}
                            size='md'
                            headerRowHeight={30}
                            rowHeight={30}
                            isRowColorful={false}
                        />
                    </div>
                </div>
            </div>
        </main>
  );
};

const TreeNode = ({ data, handleClick }) => {
    const [expandedNodes, setExpandedNodes] = useState({});

    const toggleExpand = (menuId) => {
        setExpandedNodes((prev) => ({ ...prev, [menuId]: !prev[menuId] }));
    };

    const buildTree = (data) => {
        const map = {};
        const tree = [];

        data.forEach((item) => (map[item.menuId] = { ...item, children: [] }));

        data.forEach((item) => {
            if (item.hgrnMenuId && map[item.hgrnMenuId]) {
                map[item.hgrnMenuId].children.push(map[item.menuId]);
            } else {
                tree.push(map[item.menuId]);
            }
        });
        return tree;
    };

    const treeData = buildTree(data);

    // 내부에서 트리 아이템 정의
    const TreeNodeItem = ({ node }) => (
        <div className={style.treeNode}>
            <div className={style.treeItem}>
                {node.children?.length > 0 && (
                    <span onClick={() => toggleExpand(node.menuId)} className={style.toggleIcon}>
                        {expandedNodes[node.menuId] ? "📂" : "📁"}
                    </span>
                )}
                <span className={style.treeTitle} onClick={() => handleClick(node.menuId)}>
                    {node.menuNm}
                </span>
            </div>
            {expandedNodes[node.menuId] && node.children?.length > 0 && (
                <div className={style.treeChildren}>
                    {node.children.map((child) => (
                        <TreeNodeItem key={child.menuId} node={child} />
                    ))}
                </div>
            )}
        </div>
    );

    return (
        <div>
            {treeData.map((node) => (
                <TreeNodeItem key={node.menuId} node={node} />
            ))}
        </div>
    );
};

export default MSM101F1;
